var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useEffect, useState } from "react";
import fetchTopics from "./api";
var DiscourseSearch = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    var _b = useState([]), topics = _b[0], setTopics = _b[1];
    var searchTerm = rest.searchTerm, results = rest.results;
    useEffect(function () {
        if (!searchTerm)
            return;
        var isSubscribed = true;
        var onSuccess = function (_a) {
            var data = _a.data;
            return isSubscribed && setTopics(data);
        };
        fetchTopics(searchTerm, onSuccess);
        return function () { return (isSubscribed = false); };
    }, [searchTerm]);
    return children(__assign(__assign({}, rest), { results: __assign(__assign({}, results), { discourse: topics }) }));
};
export default DiscourseSearch;
